import * as React from "react";
import { useSelector, useStore } from "react-redux";

import { Checkbox, FormControlLabel, Slide } from "@mui/material";

import { InputField } from "../components/InputField.tsx";
import { setSameDayMode } from "../Store/roiStore.ts";

import "../styles/pages/client-details.scss";

export const SameDaySetup = () => {
    const sameDay = useSelector((state: any) => state.inputFields.sameDay) ?? {
        isSameDayOnly: false,
        numberOfHospitals: 0,
    };
    const { dispatch } = useStore();

    const isSameDayOnly = !!sameDay.isSameDayOnly;
    const numberOfHospitals = Number(sameDay.numberOfHospitals ?? 0);

    return (
        <Slide direction="right" in={true} mountOnEnter unmountOnExit>
            <div className="client-details-page">
                <h1>PAR SameDay Setup</h1>
                <p className="client-details-instructions">
                    PAR SameDay is the only solution selected for this analysis. Because
                    PAR SameDay covers bill-only items brought to procedures by the
                    vendor, expiration, overstock, and daily-scanning labor savings do
                    not apply — please confirm below and the wizard will collect the
                    PAR SameDay-specific inputs and skip the standard supply-chain
                    steps.
                </p>

                <div className="client-details-form">
                    <div className="client-details-section">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={isSameDayOnly}
                                    onChange={(event) =>
                                        dispatch(
                                            setSameDayMode({
                                                isSameDayOnly: event.target.checked,
                                                numberOfHospitals: numberOfHospitals,
                                            })
                                        )
                                    }
                                />
                            }
                            label="Please confirm this is a PAR SameDay-only ROI"
                        />
                    </div>

                    {isSameDayOnly && (
                        <InputField
                            placeholder="Number of hospitals to deploy PAR SameDay"
                            label="Number of hospitals to deploy PAR SameDay"
                            value={numberOfHospitals}
                            type="number"
                            onValueInputChange={(_name, value) =>
                                dispatch(
                                    setSameDayMode({
                                        isSameDayOnly: true,
                                        numberOfHospitals: Number(value ?? 0),
                                    })
                                )
                            }
                        />
                    )}
                </div>
            </div>
        </Slide>
    );
};
